import {Component, OnInit} from '@angular/core';
import {StoresDataService} from '../../../shops/services/stores.data.service';
import {ActivatedRoute, Router} from '@angular/router';
import {GeneralService, HttpService, SettingsProvider, SnackbarService} from 'app/core';
import {Location} from '@angular/common';
import {DeleteModalComponent} from 'app/components/delete-modal/delete-modal.component';
import {MatDialog} from '@angular/material/dialog';
import {ImportDialogComponent} from 'app/components/import-dialog/import-dialog.component';
import {CategoryShelfModel, StoreListQuery} from 'app/domain/shops-wrapper/shops/model/models';
import {FilesService} from 'app/core/services/files.service';
import {environment as env} from 'environments/environment';
import {TableColumnDef} from 'app/shared/tables/table-column-def';

@Component({
    selector: 'sh-shop-floorplan',
    templateUrl: './shop-floorplan-page.component.html',
})
export class ShopFloorplanPageComponent implements OnInit {

    isLoadingFloorplan: boolean;
    isDeletingFloorplan: boolean;
    isFloorplan: boolean;

    storeId: number;
    floorplanImg: string | ArrayBuffer;
    storeData: StoreListQuery;

    saveButtonText = 'Prześlij floorplan';

    canNavigate = false;
    columnsData: TableColumnDef[];
    tableId: string;
    dataServiceMethod = 'fetchCategoryShelves';

    constructor(
        public storeService: StoresDataService,
        public generalService: GeneralService,
        private _location: Location,
        private router: Router,
        private dialog: MatDialog,
        private snackBar: SnackbarService,
        private route: ActivatedRoute,
        private filesService: FilesService,
        private httpService: HttpService,
        public settingsService: SettingsProvider,
    ) {
        this.storeId = route.snapshot.parent.params['id'];
    }

    ngOnInit() {
        this.getShopFloorplan();

        const tableInfo = CategoryShelfModel.tableInfo();
        this.tableId = tableInfo.tableId;
    }

    public getShopFloorplan(): void {
        this.isLoadingFloorplan = true;
        this.storeService.getById(this.storeId).subscribe(
            (res) => {
                this.storeData = res;
                this.isFloorplan = !!this.storeData.FloorPlanFileId;
                if (this.isFloorplan) {
                    this.getImageFromService(this.storeData.FloorPlanFileId);
                    this.saveButtonText = 'Zmień floorplan';
                } else {
                    this.isLoadingFloorplan = false;
                }
            },
            () => {
                this.snackBar.info('Błąd przy pobieraniu floorplanu');
                this.saveButtonText = 'Prześlij floorplan';
                this.isFloorplan = false;
                this.isLoadingFloorplan = false;
                this.goBack();
            },
        );
    }

    private createImageFromBlob(image: Blob) {
        const reader = new FileReader();
        reader.addEventListener('load', () => {
            this.floorplanImg = reader.result;
        }, false);

        if (image) {
            reader.readAsDataURL(image);
        }
    }

    private getImageFromService(id: string) {
        const url = `${this.settingsService.configuration.url}${env.FilesService.apiUrlGetFile}/${id}`;
        this.httpService.getBlob(url, 'image/jpeg').subscribe(data => {
            this.createImageFromBlob(data);
        });
    }

    public openImportDialog(): void {
        const dialogRef = this.dialog.open(ImportDialogComponent, {
            minWidth: '400px',
            minHeight: '100px',
            data: {
                useTemplate: false,
                importFileExt: 'img',
                warningText: this.isFloorplan ? 'Uwaga! Nowo przesłany floorplan zastąpi poprzedni.' : ' ',
                title: 'Import możliwy tylko z plików w formacie png oraz jpg',
            },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result && result.body) {
                this.storeData.FloorPlanFileId = result.body;
                this.storeService.update(this.storeData).subscribe(
                    () => {
                        this.getShopFloorplan();
                    },
                    () => {
                        this.snackBar.info('Nie udało się przypisać zdjęcia floorplanu do placówki.');
                    },
                );
            }
        });
    }

    public openDeleteDialog(): void {
        const dialogRef = this.dialog.open(DeleteModalComponent, {
            width: '300px',
            data: {name: 'floorplan dla tej placówki'},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result && result.deleted) {
                this.deleteFloorplan();
            }
        });
    }

    private deleteFloorplan(): void {
        this.isDeletingFloorplan = true;
        this.storeData.FloorPlanFileId = null;
        this.storeService.update(this.storeData).subscribe(
            () => {
                this.floorplanImg = '';
                this.isFloorplan = false;
                this.saveButtonText = 'Prześlij floorplan';
                this.snackBar.info('Floorplan został usunięty');
            },
            () => {
                this.snackBar.info('Nie udało się przypisać zdjęcia floorplanu do placówki.');
            },
            () => (this.isDeletingFloorplan = false)
        );
    }

    goBack() {
        this._location.back();
    }
}
